import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Em produção (Vercel): REACT_APP_API_URL aponta para o backend no Railway
// Em desenvolvimento: usa localhost:3001 via proxy
const API_URL = process.env.REACT_APP_API_URL || '';
if (API_URL) {
  axios.defaults.baseURL = API_URL;
}
  
  axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const isLoginRoute = error.config?.url?.includes('/api/auth/login');
      if (!isLoginRoute) {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// URL vazia = requisições relativas (/api/...) — Vercel faz proxy para o backend

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get('/api/auth/me')
        .then(r => setUser(r.data))
        .catch(() => {
          localStorage.removeItem('token');
          delete axios.defaults.headers.common['Authorization'];
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (login, password) => {
    const r = await axios.post('/api/auth/login', { login, password });
    localStorage.setItem('token', r.data.token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${r.data.token}`;
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
